export function formatEstimatedBytes(bytes: number | undefined): string | null {
  if (!bytes || bytes <= 0) {
    return null
  }

  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = bytes
  let unitIndex = 0

  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex += 1
  }

  const precision = value >= 10 || unitIndex === 0 ? 0 : 1
  return `~${value.toFixed(precision)} ${units[unitIndex]} est`
}
